import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '@svb/api-loading-component/dist/components/index';
import PropTypes from 'prop-types';
import PageNotFound from './PageNotFound';
import HealthCheckAPI from '../core/healthCheck/HealthCheckAPI';
import HealthCheckPage from '../core/healthCheck/HealthCheckPage';
import AnnonTokenWrapper from '../core/AnnonTokenWrapper';

const HomePage = lazy(() => import('./HomePage'));
const Solutions = lazy(() => import('./Solutions'));
const APIDocsContainer = lazy(() => import('./APIDocsContainer'));
const FaqsPage = lazy(() => import('./FaqsPage'));
const ContactSupport = lazy(() => import('../ui-templates/support/contact/ContactSupport'));

function PageRender(props) {
  const [loading, setloading] = useState(true);
  const contentURL = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  let { folder, folderOne, id } = useParams();
  useEffect(() => {
    // regenTokenifExpired();
    setloading(false);
  }, [folder, id]);
  if (loading) {
    return (
      <div className='pt-5 mt-2'>
        <Loading />
      </div>
    );
  }
  switch (folder) {
    case '/': {
      return (
        <div className='pt-5 mt-2'>
          <Suspense fallback={<></>}>
            <HomePage />
          </Suspense>
        </div>
      );
    }
    case 'solutions': {
      return (
        <div className='pt-5 mt-2'>
          {/* Pass URL params to render Solution Details if required */}
          <Suspense fallback={<></>}>
            <Solutions
              solutionsURL={`${contentURL}/portal-content`}
              tabKey={folderOne}
              detailsKey={id}
            />
          </Suspense>
        </div>
      );
    }
    case 'apis': {
      return (
        <div className='pt-5 mt-2'>
          {/* To render API Doc Pages */}
          <Suspense fallback={<></>}>
            <APIDocsContainer
              contenturl={`${contentURL}/portal-content`}
              id={folderOne}
              details={id}
              catalog={props?.browse}
            />
          </Suspense>
        </div>
      );
    }
    case 'contact': {
      return (
        <div className='pt-5 mt-2'>
          {/* To render Contact Support Page */}
          <Suspense fallback={<></>}>
            <ContactSupport />
          </Suspense>
        </div>
      );
    }
    case 'faqs': {
      return (
        <div className='pt-5 mt-2'>
          {/* To render Support page*/}
          <Suspense fallback={<></>}>
            <FaqsPage tabKey={id} />
          </Suspense>
        </div>
      );
    }
    case 'apis-health-status': {
      if (id === 'api') {
        return (
          <div className='pt-5 mt-2'>
            {/* To render Support page*/}
            <Suspense fallback={<></>}>
              <HealthCheckAPI token={props?.token} />
            </Suspense>
          </div>
        );
      } else if (id === undefined) {
        return (
          <div className='pt-5 mt-2'>
            {/* To render Support page*/}
            <Suspense fallback={<></>}>
              <HealthCheckPage token={props?.token} />
            </Suspense>
          </div>
        );
      } else {
        return <PageNotFound />;
      }
    }
    default: {
      return (
        <>
          <PageNotFound />
        </>
      );
    }
  }
}
export default AnnonTokenWrapper(PageRender);
PageRender.propTypes = {
  browse: PropTypes.any,
};
